var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"entryModalRef",attrs:{"size":"lg","title":_vm.entryObj.title},on:{"hide":_vm.onDismiss}},[_c('b-container',{attrs:{"fluid":""}}),(_vm.entryObj.entryId)?_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('entry-menu',{attrs:{"entry":_vm.entryObj}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }